import {
  createContext,
  useState,
  useContext,
  ReactNode,
  useEffect,
  Dispatch,
  SetStateAction,
} from "react";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";

export const companyOptions = [
  { key: "CVFLogistics", label: "CVF Logística", value: 1 },
  { key: "CVFDistributions", label: "CVF Distribuidora", value: 2 },
  { key: "CVFRondonia", label: "CVF Rondônia", value: 3 },
  { key: "WTrading", label: "W Trading", value: 4 },
  { key: "General", label: "Todas", value: 5 },
];

// Unidades que a empresa do usuário interno enxerga — espelha ProcessAccessRules.GetAllowedProcessTypes
// no backend. null = todas ("Geral"); empresa não reconhecida = nenhuma.
export const allowedCompanyValues = (company?: string | null): number[] | null => {
  const name = (company ?? "").trim().toUpperCase();
  if (name.includes("GERAL")) return null;
  if (name.includes("LOG")) return [1];
  if (name.includes("DISTR")) return [2, 3, 4];
  if (name.includes("ROND")) return [3];
  if (name.includes("W TRADING")) return [4];
  return [];
};

export interface CompanyContextProps {
  currentCompany: number | undefined;
  setCurrentCompany: (val: number | undefined) => void;
  currentEmulation: string | undefined;
  setCurrentEmulation: (val: string | undefined) => void;
}

const CompanyContext = createContext<CompanyContextProps>({
  currentCompany: undefined,
  setCurrentCompany: () => {},
  currentEmulation: undefined,
  setCurrentEmulation: () => {},
});

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error("useCompany must be used within a CompanyProvider");
  }
  return context;
};

export const CompanyProvider = ({ children }: { children: ReactNode }) => {
  const [currentCompany, setCurrentCompany] = useState<number>();
  const [currentEmulation, setCurrentEmulation] = useState<string>();
  const auth = useAuthUser<any>();

  const handleChangeCompany = (val: number | undefined) => {
    setCurrentCompany(val);
    if (!!val) {
      localStorage.setItem("appCompany", val.toString());
    } else {
      localStorage.removeItem("appCompany");
    }
  };
  const handleChangeEmulation = (val: string | undefined) => {
    setCurrentEmulation(val);
    if (!!val) {
      localStorage.setItem("appClient", val.toString());
    } else {
      localStorage.removeItem("appClient");
    }
  };

  useEffect(() => {
    const savedCompany = localStorage.getItem("appCompany");
    if (savedCompany != null) {
      setCurrentCompany(parseFloat(savedCompany));
    } else {
      switch (auth?.company) {
        case "CVF Logística":
          setCurrentCompany(1);
          break;
        case "CVF Distribuidora":
          setCurrentCompany(2);
          break;
        case "CVF Rondônia":
          setCurrentCompany(3);
          break;

        case "W Trading":
          setCurrentCompany(4);
          break;
        default:
          setCurrentCompany(5);
          break;
      }
    }
    const savedClient = localStorage.getItem("appClient");
    if (savedClient != null) {
      setCurrentEmulation(savedClient);
    }
  }, []);

  useEffect(() => {
    if (auth?.company !== "Geral" && auth?.company !== "CVF Distribuidora") {
      console.log("asd-a", auth?.company);
      switch (auth?.company) {
        case "CVF Logística":
          setCurrentCompany(1);
          break;
        case "CVF Distribuidora":
          setCurrentCompany(2);
          break;
        case "CVF Rondônia":
          setCurrentCompany(3);
          break;

        case "W Trading":
          setCurrentCompany(4);
          break;
        default:
          setCurrentCompany(5);
          break;
      }
    } else if (auth?.company === "CVF Distribuidora") {
      // Distribuidora opera Distribuidora/Rondônia/W Trading; unidade salva fora disso (ex.: "Todas") volta p/ Distribuidora
      setCurrentCompany((current) => (current && [2, 3, 4].includes(current) ? current : 2));
    }
  }, [auth]);

  const value = {
    currentCompany,
    setCurrentCompany: handleChangeCompany,
    currentEmulation,
    setCurrentEmulation: handleChangeEmulation,
  };

  return (
    <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>
  );
};
